export default __webpack_public_path__ + "static/media/person_2.43893f68.png";